/**
 * BRM values shared by more than one screen, so a settings page never has to import a display page's config.
 */

/**
 * Ready to Pick Queue Count range offered in Site Settings → BRM (ST-2696). The server keeps its own copy
 * (MIN/MAX_READY_TO_PICK_QUEUE_COUNT in DAO/batteriesSettingsDAO.js and
 * brm_site_settings.ready_to_pick_queue_count in iotah-common validationRules.json) — change all three together.
 */
export const BRM_READY_TO_PICK_QUEUE_COUNT: Readonly<{ min: number; max: number }> = Object.freeze({ min: 1, max: 4 });
